// 1) Helper to load the whole tooltips-state (or get defaults)
function getTutorialState() {
  const json = localStorage.getItem("hintState");
  return json ? JSON.parse(json) : {
    hideDrawingHint: false,
    hideUploadHint: false,
    hideResultHint: false,
    hidePlannerHint: false,
  };
}

// 2) Helper to save it back
function saveTutorialState(state) {
  localStorage.setItem("hintState", JSON.stringify(state));
}

// 3) To hide a specific tooltip:
export function hideTutorialHint(name) {
  const state = getTutorialState();
  state[name] = true;
  saveTutorialState(state);
}

// 4) To check whether to show a tooltip:
export function isTutorialHintHidden(name) {
  const state = getTutorialState();
  return state[name];
}
